import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrlApi } from '../../utils/url';
import { RootState } from './store';

export interface PictureroomPhoto {
  id: number;
  url: string;
  type: string;
  RoomId: number;
  RoomstateId: number | null;
}

interface PictureroomState {
  picturesByLocal: PictureroomPhoto[];
  loading: boolean;
  error: string | null;
}

const initialState: PictureroomState = {
  picturesByLocal: [],
  loading: false,
  error: null,
};

const getToken = (state: RootState) => (state as any).authentification?.user?.token;

export const fetchPictureroomsByLocal = createAsyncThunk<PictureroomPhoto[], number, { state: RootState }>(
  'pictureroom/fetchByLocal',
  async (localId, { getState, rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrlApi}/picturerooms/local/${localId}`, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Failed');
    }
  }
);

export const uploadPictureroom = createAsyncThunk<
  void,
  { roomId: number; file: File; type: string; roomstateId?: number; localId: number },
  { state: RootState }
>(
  'pictureroom/upload',
  async ({ roomId, file, type, roomstateId, localId }, { getState, dispatch, rejectWithValue }) => {
    try {
      const fd = new FormData();
      fd.append('photosroom', file);
      fd.append('type', type);
      if (roomstateId !== undefined) fd.append('RoomstateId', String(roomstateId));
      await axios.post(`${baseUrlApi}/rooms/${roomId}/pictures/`, fd, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      dispatch(fetchPictureroomsByLocal(localId));
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Upload failed');
    }
  }
);

export const deletePictureroom = createAsyncThunk<
  void,
  { picId: number; localId: number },
  { state: RootState }
>(
  'pictureroom/delete',
  async ({ picId, localId }, { getState, dispatch, rejectWithValue }) => {
    try {
      await axios.delete(`${baseUrlApi}/picturerooms/${picId}`, {
        headers: { Authorization: `bearer ${getToken(getState())}` },
      });
      dispatch(fetchPictureroomsByLocal(localId));
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Delete failed');
    }
  }
);

const pictureroomSlice = createSlice({
  name: 'pictureroom',
  initialState,
  reducers: {
    clearPicturerooms: (state) => { state.picturesByLocal = []; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPictureroomsByLocal.pending,  (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPictureroomsByLocal.rejected, (state, action: any) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchPictureroomsByLocal.fulfilled, (state, action) => {
        state.loading          = false;
        state.picturesByLocal  = action.payload;
      });
  },
});

export const { clearPicturerooms } = pictureroomSlice.actions;
export default pictureroomSlice.reducer;
